import { FormKitNode } from "@formkit/core";

const togglePasswordRevealed = (node: FormKitNode) => {
  node.props.suffixIcon = node.props.suffixIcon === 'eye' ? 'eyeClosed' : 'eye';
  node.props.type = node.props.type === 'password' ? 'text' : 'password';
};

/**
 * Adds an event listener to the suffix icon of an autocomplete input.
 * The event listener will emit an event telling the autocomplete to open the grid lookup.
 */
const plugin = (node: FormKitNode) => {
  if (node.type === "input"
    && node.props.type === "password"
    && node.props.suffixIcon === "eye") {

    node.props.onSuffixIconClick = () => {
      if (!node.props.disabled && !node.props.readonly) {
        togglePasswordRevealed(node);
      }
    };
  }
};

export default plugin;
